/*
 * Copyright (c) 2023. Henry Zilek
 */

import {createRouter, createWebHistory} from "vue-router";
import store from "@/store";

const routes = [
    {
        path: "/",
        name: "Home",
        component: () => import(/* webpackChunkName: "Home" */ "@/views/MainView.vue"),
        props: true,
    },
    {
        path: "/contact",
        name: "Contact",
        component: () => import(/* webpackChunkName: "Contact" */ "@/views/ContactView.vue"),
        props: true,
    },
    {
        path: "/offer",
        name: "Offer",
        component: () => import(/* webpackChunkName: "Offer" */ "@/views/OfferView.vue"),
        props: true,
    },
    {
        path: "/project",
        name: "Project",
        component: () => import(/* webpackChunkName: "Project" */ "@/views/ProjectView.vue"),
        props: true,
    },
    {
        path: "/about",
        name: "About",
        component: () => import(/* webpackChunkName: "About Us" */ "@/views/AboutUsView.vue"),
        props: true,
    },
    {
        path: "/dictionary",
        name: "Dictionary",
        component: () => import(/* webpackChunkName: "Dictionary" */ "@/views/DictionaryView.vue"),
        props: true,
    },
    {
        path: "/gdpr",
        name: "Gdpr",
        component: () => import(/* webpackChunkName: "Gdpr" */ "@/views/GdprView.vue"),
        props: true,
    },
    {
        path: "/vop",
        name: "Vop",
        component: () => import(/* webpackChunkName: "Vop" */ "@/views/VopView.vue"),
        props: true,
    },
    {
        path: "/cookies",
        name: "Cookies",
        component: () => import(/* webpackChunkName: "Cookies" */ "@/views/CookiesView.vue"),
        props: true,
    },
    {
        path: "/test",
        name: "Test",
        component: () => import(/* webpackChunkName: "Test" */ "@/views/TestView.vue"),
        props: true,

    },
    {
        path: "/menu",
        name: "Menu",
        component: () => import(/* webpackChunkName: "Test" */ "@/components/menu/MobileMenu.vue"),
        props: true,

    },

    {
        path: "/login/:goto",
        name: "Login",
        component: () => import(/* webpackChunkName: "Login" */ "@/views/LoginView.vue"),
    },
    {
        path: "/admin",
        name: "Admin",
        component: () => import(/* webpackChunkName: "Admin" */ "@/components/administration/AdminBlock.vue"),
        props: true,
        meta: {requiresAuth: true},
        children: [
            {
                path: "/admin/ourPeople",
                name: "OurPeople",
                props: true,
                meta: {requiresAuth: true},
                component: () => import(/* webpackChunkName: "OurPeople" */ "@/components/administration/AdminOurPeople.vue")

            },
            {
                path: "/admin/category",
                name: "Category",
                props: true,
                meta: {requiresAuth: true},
                component: () => import(/* webpackChunkName: "Category" */ "@/components/administration/AdminCategory.vue")

            },
            {
                path: "/admin/fabicons",
                name: "FabIcons",
                props: true,
                meta: {requiresAuth: true},
                component: () => import(/* webpackChunkName: "FabIcons" */ "@/components/administration/AdminFabIcons.vue")

            },
            {
                path: "/admin/customerlogo",
                name: "CustomerLogo",
                props: true,
                meta: {requiresAuth: true},
                component: () => import(/* webpackChunkName: "CustomerLogo" */ "@/components/administration/AdminCustomerLogo.vue")

            },
            {
                path: "/admin/upload",
                name: "FileUpload",
                component: () => import(/* webpackChunkName: "FileUpload" */ "@/components/administration/FileUpload.vue"),
                props: true,
                meta: {requiresAuth: true},
            },
            {
                path: "/admin/shortarticle",
                name: "ShortArticle",
                component: () => import(/* webpackChunkName: "ShortArticle" */ "@/components/administration/AdminShortArticle.vue"),
                props: true,
                meta: {requiresAuth: true},
            },
            {
                path: "/admin/config",
                name: "Config",
                component: () => import(/* webpackChunkName: "Config" */ "@/components/administration/AdminConfig.vue"),
                props: true,
                meta: {requiresAuth: true},
            },
        ],
    },
]


const router = createRouter(
    {
        routes,
        history: createWebHistory(),
        scrollBehavior(to) {
            if (to.hash) {
                return {
                    el: to.hash,
                    behavior: 'smooth'
                };
            }
            return {x: 0, y: 0};  // Go to the top of the page if no hash
        },
    }
)

router.beforeEach((to, from, next) => {
    init()
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.state.userName.length === 0 || !store.state.isAdmin) {
            next({name: "Login", params: {goto: to.name}});
        } else {
            next();
        }
    } else {
        next();
    }

})


async function init() {
    if (!store.state.dataSettingLoaded) {
        await store.dispatch('getSetting', 'config.json');
    }

}

export default router